import { createSlice } from '@reduxjs/toolkit';

import type { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import type { DisplaysState } from '~/renderer/store/displays/types';

const initialState: DisplaysState = {
  selectedDisplay: undefined,
  displays: [] as Electron.Display[],
  isFullscreen: false,
};

const updateDisplays: CaseReducer<DisplaysState, PayloadAction<Electron.Display[]>> = (
  state,
  action,
) => {
  state.displays = action.payload;
};

const updateSelectedDisplay: CaseReducer<
  DisplaysState,
  PayloadAction<DisplaysState['selectedDisplay']>
> = (state, action) => {
  state.selectedDisplay = action.payload;
};

const updateIsFullscreen: CaseReducer<DisplaysState, PayloadAction<boolean>> = (state, action) => {
  state.isFullscreen = action.payload;
};

const displaysSlice = createSlice({
  name: 'displays',
  initialState,
  reducers: {
    updateDisplays,
    updateSelectedDisplay,
    updateIsFullscreen,
  },
});

const { actions, reducer } = displaysSlice;
export { reducer as displaysReducer, actions as displaysActions };
